// This is the metadata for all of my KA projects

export const KAGames = [
    {
        title: "A Block Game",  // Title of project
        codeLocation: "./PJSCode/ABlockGame.js",  // path to PJS code
        votes: "97",  // number of votes on KA
        rating: 3,  // from 1 to 10. They will de displayed from best to worst
        dateOfCreation: "2016", // text format (because some of them I only know the year)
    },
    {
        title: "Agar.io",  // Title of project
        codeLocation: "./PJSCode/Agario.js",  // path to PJS code
        votes: "70",  // number of votes on KA
        rating: 6,  // from 1 to 10. They will de displayed from best to worst
        dateOfCreation: "2018", // text format (because some of them I only know the year)
    },
    {
        title: "Whack-a-pole",  // Title of project
        codeLocation: "./PJSCode/WhackAPole.js",  // path to PJS code
        votes: "74",  // number of votes on KA
        rating: 5,  // from 1 to 10. They will de displayed from best to worst
        dateOfCreation: "Nov 2019", // text format (because some of them I only know the year)
    },
];